export const GLOBAL_STATE = 'Country'

export const COUNTRY = 'country'
export const COUNTRY_LIST = 'countryList'
export const COUNTRY_ALL = 'countryAll'
export const COUNTRY_CREATE = 'countryCreate'
